import {
  receiveUserSettings,
  showTransientNotification,
} from '@driftt/traffic-control'
import { pathOr } from 'ramda'
import { connect } from 'react-redux'

import { setPlaybookType } from 'modules/editor/actions'
import { receivePlaybook } from 'modules/playbook/actions'

const mapStateToProps = (state) => {
  return {
    landingPageStatus: pathOr(
      {},
      ['__PLAYBOOK_EDITOR', 'landingpages', 'settings', 'status'],
      state
    ),
    landingPageSettings: pathOr(
      {},
      ['__PLAYBOOK_EDITOR', 'landingpages', 'settings'],
      state
    ),
    landingPageSubdomain: pathOr(
      '',
      ['__PLAYBOOK_EDITOR', 'landingpages', 'subdomain'],
      state
    ),
    landingPageCname: pathOr(
      '',
      ['__PLAYBOOK_EDITOR', 'landingpages', 'cname', 'cname'],
      state
    ),
    landingPageCnameStatus: pathOr(
      '',
      ['__PLAYBOOK_EDITOR', 'landingpages', 'cname', 'status'],
      state
    ),
    playbookErrors: pathOr(
      {},
      ['__PLAYBOOK_EDITOR', 'playbookValidation'],
      state
    ),
    playbook: state.__PLAYBOOK_EDITOR.playbook,
    userId: state.user.id,
    showConvoContentHighlightTooltip:
      state.__PLAYBOOK_EDITOR.playbook.reportType === 'CONVO_CONTENT_CLP' &&
      pathOr(
        true,
        ['user', 'settings', 'showConvoContentHighlightTooltip'],
        state
      ),
    hasSeenBotTestingTooltip:
      state.user.settings.hasSeenBotTestingTooltip || false,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onReceivePlaybook: (playbook) => {
      dispatch(receivePlaybook(playbook))
      dispatch(setPlaybookType(playbook.reportType))
    },
    onReceiveUserSettings: (settings) => {
      dispatch(receiveUserSettings(settings))
    },
    showTransientNotification: (config) => {
      dispatch(showTransientNotification(config))
    },
  }
}

export default (Component) =>
  connect(mapStateToProps, mapDispatchToProps)(Component)
